import React from 'react';

/** @internal */
export var filterIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.32061 15.2457C2.82393 15.2457 1.60547 14.0279 1.60547 12.5306C1.60547 11.0336 2.82393 9.81543 4.32061 9.81543C5.81728 9.81543 7.03575 11.0336 7.03575 12.5306C7.03575 14.0279 5.81728 15.2457 4.32061 15.2457ZM4.32089 11.175C3.57357 11.175 2.96535 11.7833 2.96535 12.5306C2.96535 13.2779 3.57357 13.8861 4.32089 13.8861C5.06822 13.8861 5.67643 13.2779 5.67643 12.5306C5.67643 11.7833 5.06822 11.175 4.32089 11.175Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4437 19.3072C10.947 19.3072 9.72852 18.0894 9.72852 16.5921C9.72852 15.0951 10.947 13.877 12.4437 13.877C13.9403 13.877 15.1588 15.0951 15.1588 16.5921C15.1588 18.0894 13.9403 19.3072 12.4437 19.3072ZM12.4439 15.2368C11.6966 15.2368 11.0884 15.8446 11.0884 16.592C11.0884 17.3393 11.6966 17.9475 12.4439 17.9475C13.1913 17.9475 13.7995 17.3393 13.7995 16.592C13.7995 15.8446 13.1913 15.2368 12.4439 15.2368Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5667 11.1852C19.07 11.1852 17.8516 9.96738 17.8516 8.47002C17.8516 6.97301 19.07 5.75488 20.5667 5.75488C22.0634 5.75488 23.2818 6.97301 23.2818 8.47002C23.2818 9.96738 22.0634 11.1852 20.5667 11.1852ZM20.567 7.11449C19.8197 7.11449 19.2115 7.7227 19.2115 8.47003C19.2115 9.21735 19.8197 9.82557 20.567 9.82557C21.3143 9.82557 21.9225 9.21735 21.9225 8.47003C21.9225 7.7227 21.3143 7.11449 20.567 7.11449Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.32145 1.7002C3.94745 1.7002 3.64453 2.00312 3.64453 2.37712V10.5002C3.64453 10.8739 3.94745 11.1771 4.32145 11.1771C4.69545 11.1771 4.99838 10.8739 4.99838 10.5002V2.37712C4.99838 2.00312 4.69545 1.7002 4.32145 1.7002Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.32145 13.8848C3.94745 13.8848 3.64453 14.1877 3.64453 14.5617V22.6848C3.64453 23.0588 3.94745 23.3617 4.32145 23.3617C4.69545 23.3617 4.99838 23.0588 4.99838 22.6848V14.5617C4.99838 14.1877 4.69545 13.8848 4.32145 13.8848Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4445 1.7002C12.0705 1.7002 11.7676 2.00312 11.7676 2.37712V14.5617C11.7676 14.9357 12.0705 15.2387 12.4445 15.2387C12.8185 15.2387 13.1214 14.9357 13.1214 14.5617V2.37712C13.1214 2.00312 12.8185 1.7002 12.4445 1.7002Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4445 17.9463C12.0705 17.9463 11.7676 18.2492 11.7676 18.6232V22.6848C11.7676 23.0588 12.0705 23.3617 12.4445 23.3617C12.8185 23.3617 13.1214 23.0588 13.1214 22.6848V18.6232C13.1214 18.2492 12.8185 17.9463 12.4445 17.9463Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5675 1.7002C20.1935 1.7002 19.8906 2.00312 19.8906 2.37712V6.43866C19.8906 6.81232 20.1935 7.11558 20.5675 7.11558C20.9415 7.11558 21.2445 6.81232 21.2445 6.43866V2.37712C21.2445 2.00312 20.9415 1.7002 20.5675 1.7002Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5675 9.82324C20.1935 9.82324 19.8906 10.1262 19.8906 10.5002V22.6848C19.8906 23.0588 20.1935 23.3617 20.5675 23.3617C20.9415 23.3617 21.2445 23.0588 21.2445 22.6848V10.5002C21.2445 10.1262 20.9415 9.82324 20.5675 9.82324Z"
}));